import React, {useMemo, useState } from 'react';
import { getLocale, shallowEqual, useDispatch, useIntl, useSelector } from 'umi';
import './index.scss';
import { List, SearchBox, Segment } from 'tea-component';
import { trim , uniqBy } from 'lodash-es';
// import TextBubbles from '../TextBubbles';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { DateShortcutType, shortcutOptionDefualt } from '../NewFilter/FilterBase/shortcutOptionDefualt';
import { getExtraShortcut } from '../NewFilter/FilterBase/getExtraShortcut';
import TextBubbles from '@/pages/home/components/TextBubbles';
import NoData from "@/pages/dashboard/components/NoData";

import moment from 'moment';

interface IProps {
  latestDate: string;
  startOfTime: string;
  seasonInfo: any;
  activeTab: string;
  handleChangeValue: Function;
  setSelectLeftType: Function;
  selectedLeftType: string;
  childRef: React.Ref<HTMLDivElement>;
  type: string;
  eventTypeClick?: Function;
  dateFilterKey:string;
  changeClose?: boolean; // 用户选择日期变化时是否关闭弹窗, 默认为true 关闭弹窗
  hideEventTab?: boolean;
  customShortcuts?: any[];
}

const RangePickerLeft = (props: IProps) => {
  const {
    latestDate,
    startOfTime,
    seasonInfo,
    handleChangeValue,
    setSelectLeftType,
    selectedLeftType,
    childRef,
    eventTypeClick,
    dateFilterKey='normal',
    type,
    changeClose = true,
    hideEventTab = false,
    customShortcuts,
  } = props;
  const { formatMessage } = useIntl();
  const [searchValue, setsearchValue] = useState('');
  const isEn = getLocale() === 'en-US';
  const dispatch = useDispatch();
  const rangePickerLeftData = useSelector((state: any) => state.rangePikerLeft?.rangePickerLeftData, shallowEqual);

  const rangePickerLeftDataInit = rangePickerLeftData?.filter(item=>item?.dateFilterKey === dateFilterKey);
  const {
    // dateFilterKey:dateFilterKeyInit,
    selectedEventId: selectedEventIdInit,
    eventSelectedChild: eventSelectedChildInit,
    tabActiveTab: tabActiveTabInit
  } = rangePickerLeftDataInit?.[0] || {};

  // const dateFilterKeyIsEqual = dateFilterKey === dateFilterKeyInit;
  const [selectedEventId, setSelectedEventId] = useState((selectedEventIdInit) ? selectedEventIdInit : 'all');
  const [eventSelectedChild, setEventSelectedChild] = useState((eventSelectedChildInit) || '');
  const [tabActiveTab, setTabActiveTab] = useState(
    hideEventTab ? 'common' : (tabActiveTabInit || 'common'),
  );

  const commonDataList = customShortcuts?.length
    ? customShortcuts
    : shortcutOptionDefualt(startOfTime, latestDate, seasonInfo, dispatch)?.[type];
  const eventData = getExtraShortcut(seasonInfo);
  const eventRenderDataList = eventData?.[type];
  const eventDataTypeList = useMemo(() => {
    const rusultArr = Object.values(eventRenderDataList.reduce((acc: any, obj: DateShortcutType) => {
      const key = obj.event_type_name_en;
      if (!acc.all) {
        acc.all = {
          event_type_name: 'all',
          event_type_name_cn: "全部",
          event_type_name_en: "All",
          children: []
        };
      }
      if (!acc[key]) {
        acc[key] = {
          event_type_name: key,
          event_type_name_en: obj?.event_type_name_en,
          // 后端取消了cn传参，但是all的时候还是要区分中英文的，所以前端中文字段保留
          event_type_name_cn: obj?.event_type_name_en,
          children: []
        };
        obj.isGroup = true;
      } else {
        obj.isGroup = false;
      }
      acc[key].children.push(obj);
      acc.all.children.push(obj);
      return acc;
    }, {}));

    const allItem = rusultArr.find(item => item.event_type_name === 'all');
    const restItems = rusultArr.filter(item => item.event_type_name !== 'all');
    const result = [allItem, ...restItems];
    return result;
  }, [seasonInfo, type]);

  const dispatchData = (tabActiveTabVal: string, selectedEventIdVal: string, eventSelectedChildVal: string) => {
    dispatch({
      type: 'rangePikerLeft/setRangePickerLeftData',
      payload: {
        data: uniqBy([{
          dateFilterKey,
          tabActiveTab: tabActiveTabVal,
          selectedEventId: selectedEventIdVal,
          eventSelectedChild: eventSelectedChildVal
        },...(rangePickerLeftData || [])],'dateFilterKey')
      },
    });
  };

  const getFilteredData = (searchValue: string) => {
    const filteredData = eventDataTypeList?.filter(item => 
      // const eventTypeName = isEn ? item.event_type_name_en : item.event_type_name_cn;
      (
        item?.children?.some((child: any) => {
          const name = isEn ? child.name : child.nameCN;
          return name.toLowerCase().includes(searchValue.toLowerCase());
        })
      )
    ).map(item => ({
      ...item,
      children: item?.children?.filter((child: any) => {
        const name = isEn ? child.name : child.nameCN;
        return name.toLowerCase().includes(searchValue.toLowerCase());
      })
    }));
    return filteredData;
  };

  const realEventTypeList = useMemo(() => {
    const searchStr = trim(searchValue).toLowerCase();
    if (!searchStr) {
      return eventDataTypeList;
    }
    return getFilteredData(searchValue);
  }, [searchValue, isEn]);

  const eventDataList = useMemo(() => {
    const result = realEventTypeList?.filter(item => (item?.event_type_name === selectedEventId))?.[0]?.children || [];
    return result;
  }, [realEventTypeList, selectedEventId, searchValue]);

  const showEventTab = !hideEventTab;
  const currentTab = showEventTab ? tabActiveTab : 'common';

  return (
    <div className={`dbd-rangepicker-left${hideEventTab ? ' dbd-rangepicker-left--no-event' : ''}`}>
      {showEventTab && (
        <Segment
          className="dbd-rangepicker-left-segment"
          value={tabActiveTab}
          onChange={(value) => {
            setTabActiveTab(value);
            dispatchData(value, selectedEventId, eventSelectedChild);
            setsearchValue('');
          }}
          options={[
            { text: formatMessage({ id: 'common_common' }), value: 'common' },
            { text: formatMessage({ id: 'common_event' }), value: 'event' },
          ]}
        />
      )}
      {currentTab == 'common' ? (
        <List type="option" className="dbd-common-box">
          {commonDataList?.map((item, index) => (
            <List.Item className={`dbd-common-box-item ${selectedLeftType === item?.name && 'dbd-rangepicker-shortcut-hover'}`}
              key={item?.name + index} 
              onClick={() => {
                handleChangeValue(item?.onClick(), type);
                setSelectLeftType(item);
                //  关闭时间组件弹出窗
                changeClose && childRef?.current?.setPopActive();
              }}>
              {isEn ? item?.name : item?.nameCN}
            </List.Item>
          ))}
        </List>
      ) : (
        <>
          <SearchBox
            className="dbd-rangepicker-left-search"
            value={searchValue}
            onChange={(value: any) => {
              setsearchValue(value);
            }}
            placeholder={formatMessage({ id: 'common_search' })}
            onClick={(e) => {
              e?.stopPropagation();
              e?.target?.focus();
            }}
          />
          {
            (eventRenderDataList?.length > 0 && realEventTypeList?.length > 0) ? <div className="dbd-rangepicker-left-box">
              <div className="dbd-left-list">
                <List type="option">
                  {realEventTypeList?.map((item, index) => (
                    <List.Item
                      key={item?.event_type_name_en + index}
                      className="dbd-left-item"
                      selected={selectedEventId == item?.event_type_name}
                      onClick={() => {
                        // handleChangeValue(item?.onClick(), type);
                        setSelectedEventId(item?.event_type_name);
                        dispatchData(tabActiveTab, item?.event_type_name, eventSelectedChild);
                        // childRef?.current?.setPopActive()
                        // setSlist(item.children);
                      }}
                    >

                      <TextBubbles
                        className='dbd-left-text dbd-left-item-text-bubble-span dbd-left-item-text-bubble '
                        placement="right"
                        text={
                          isEn ? item?.event_type_name_en : item?.event_type_name_cn
                        }
                      />
                      <SvgIcon type="point-right" className="dbd-left-icon" />
                    </List.Item>
                  ))}
                </List>
              </div>
              <div className="dbd-right-list">
                <List type="option">
                  {eventDataList.map((item: any, index: number) => {
                    const name = isEn ? item?.name : item?.nameCN;
                    let dateDom = null;
                    try {
                      const startTime = moment(item.start_date).format(
                        'YYYY-MM-DD',
                      );
                      const endTime = moment(item.end_date).format(
                        'YYYY-MM-DD',
                      );
                      dateDom = (
                        <TextBubbles
                          className="dbd-right-item-text-bubble"
                          placement="right"
                          text={
                            <div className="dbd-right-item-text dbd-right-item-text-date dbd-right-item-text-bubble-span">{`${startTime} ~ ${endTime}`}</div>
                          }
                        />
                      );
                    } catch {
                      console.warn(`${name} event date error`);
                    }
                  
                    return (
                      <List.Item
                        className="dbd-right-item"
                        key={item.type + index}
                        selected={eventSelectedChild == item.type}
                        onClick={() => {
                          setEventSelectedChild(item.type);
                          dispatchData(tabActiveTab, selectedEventId, item.type);
                          handleChangeValue(item?.onClick(), type);
                          eventTypeClick?.(item);
                          changeClose && childRef?.current?.setPopActive();
                        }}
                      >
                        <TextBubbles
                          className='dbd-right-item-text-bubble'
                          placement="right"
                          text={
                            <div className='dbd-right-item-text dbd-right-item-text-bubble-span'
                              dangerouslySetInnerHTML={{
                                __html: !searchValue ? name : (name.replace(new RegExp(searchValue, 'gi'), '<span style="color: blue">$&</span>'))
                              }}></div>
                          }
                        />
                        {dateDom}
                      </List.Item>
                    );
                  })}
                </List>
              </div>
            </div> : <NoData className='dbd-rangepicker-left-nodata' text={formatMessage({ id: 'common_event_selector_nodata' })} />
          }
        </>
      )}
    </div>
  );
};

export default RangePickerLeft;
